/**
 * Genesys cloud stores some data in local storage.
 * This function removes it to be able to auto login again.
 */
export const purgeLocalStorage = () => {
  Object.keys(localStorage)
    .filter((key) => key.startsWith('_act') || key.includes(':gcm') || key.startsWith('_gca'))
    .forEach((key) => localStorage.removeItem(key));
};
